import React, { useState, useEffect } from "react";
import NavBar from "../../components/Navbar";
import styles from "../../styles/screens/Profile/Profile.module.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import BasicDetails from "./BasicDetails";
import { Oval } from "react-loader-spinner";
import {
  doc,
  getDoc
} from "firebase/firestore";
import { db } from "../../utils/firestoredb";
import SavedAddress from "./SavedAddress";
import { usePostHog } from "posthog-js/react";
import AmritjalFooter from "../../components/Amritjal_hp/AmritjalFooter";
import logo from "../../assets/amritjal_hp/Logo.png"
import Metadata from "../../components/metadata/MetaData";

const ProfilePage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const phoneNumber = JSON.parse(localStorage.getItem("phoneNumber"));
  const [language, setLanguage] = useState("en");
  const [orderHistory, setOrderHistory] = useState([]);
  const posthog = usePostHog();
  const [user, setUser] = useState(null);
  const userType = localStorage.getItem("userType");
  const [expandedOrders, setExpandedOrders] = useState([]);
  const defaultImage = "https://d3vqmpzcil03dt.cloudfront.net/webite-assets/dharmik_logo.png";
  console.log(orderHistory)
  const [loading, setLoading] = useState(false)
  const isLoggedIn = JSON.parse(localStorage.getItem("phoneNumber"))
    ? true
    : false;

  if (!isLoggedIn) navigate("/login");

  useEffect(() => {
    const currentLanguage = i18n.language;
    setLanguage(currentLanguage);
  }, [i18n.language]);

  useEffect(() => {
    const fetchUsers = async () => {
          var reff;
          if (userType === "merchant") reff = "merchants";
          else reff = "users";
    
          const userRef = doc(db, reff, phoneNumber);
          const userSnapshot = await getDoc(userRef);
          const user = userSnapshot.data();
          if(userSnapshot.exists()) {
            setUser(user);
          }
        };
    

    const fetchOrderHistory = async () => {
      setLoading(true);
      const orderPendingRef = doc(db, "order_history", phoneNumber);
      const querySnapshot = await getDoc(orderPendingRef);
      const data = querySnapshot.data() ? Object.values(querySnapshot.data()) : [];
      const filteredData = data.filter((order) => order.rzp_status === "paid");
      setOrderHistory(filteredData);
      setLoading(false);
    };

    fetchUsers();
    fetchOrderHistory();
  }, [phoneNumber,userType]);

  useEffect(() => {
    posthog.capture("$pageview");
  }, [posthog]);

  const [panelOption, setPanelOption] = useState("orders");

  const handlePanelOptionChange = (option) => {
    setPanelOption(option);
  };

  const toggleShippingAddress = (orderId) => {
   
    // Toggle the expanded state as before
    setExpandedOrders(prev => 
      prev.includes(orderId) 
        ? prev.filter(id => id !== orderId) 
        : [...prev, orderId]
    );
  };

  let panelContent;
  if (panelOption === "basic") {
    panelContent = <BasicDetails />;
  } else if (panelOption === "orders") {
    panelContent = (
      <div className={styles.container}>
        <div className="card">
          {loading ? ( // Show the loader while loading
            <div className={styles.loaderContainer}>
              <Oval
                color="#ff8e4d"
                height="20%"
                width="20%"
                strokeWidth={4}
                ariaLabel="Loading"
                wrapperClass="loader"
              />
            </div>
          ) : orderHistory.length > 0 ? ( // Show orders if available
            orderHistory
              .filter((order) => order.rzp_status === "paid")
              .map((order) => (
                <div key={order.orderId} className={styles.orderItemContainer}>
                  <div className={styles.orderItem}>
                    {/* Left Section */}
                    <div className={styles.leftSection}>
                      <img
                        src={order.image}
                        alt={order.pujaname}
                        className={styles.orderImage}
                      />
                      <div className={styles.productTitle}>
                        <div className={styles.pujaName}>
                          {language === "en"
                            ? order.pujaname
                            : order.hindi_pujaname}
                        </div>
                        <div className={styles.orderNumber}>
                          Order Number: {order.orderId}
                        </div>
                      </div>
                    </div>
                    {/* Right Section */}
                    <div className={styles.rightSection}>
                      <div className={styles.price}>₹{order.price}</div>
                      <div className={styles.quantity}>
                        Quantity: {order.quantity}
                      </div>
                      <button
                        className={styles.dropdownArrow}
                        onClick={() => toggleShippingAddress(order.orderId)}
                      >
                        {expandedOrders.includes(order.orderId) ? "▲" : "▼"}
                      </button>
                    </div>
                  </div>
    
                  {/* Shipping Address Dropdown Sheet */}
                  {expandedOrders.includes(order.orderId) && (
                    <div className={styles.shippingAddressSheet}>
                      <div className={styles.shippingAddressContent}>
                        <h4>{t("Shipping Address")}</h4>
                        {order.address ? (
                          <div className={styles.addressDetails}>
                            <p>{order.name || ""}</p>
                            <p>{order.address.house || ""}</p>
                            <p>{order.address.locality || ""}</p>
                            <p>
                              {order.address.city
                                ? `${order.address.city}, `
                                : ""}
                              {order.address.state || ""}
                            </p>
                            <p>
                              {order.address.pincode
                                ? `${order.address.city || ""} - ${
                                    order.address.pincode
                                  }`
                                : ""}
                            </p>
                            <p>{order.phone ? `${order.phone}` : ""}</p>
                          </div>
                        ) : (
                          <div className={styles.noAddressMessage}>
                            <p>{t("No address found for this order")}</p>
                          </div>
                        )}
    
                        {/* New buttons section */}
                        <div className={styles.actionButtons}>
                          {order.productvideo && (
                            <button
                              className={`${styles.actionButton} ${styles.videoButton}`}
                              onClick={() =>
                                window.open(order.productvideo, "_blank")
                              }
                            >
                              <span className={styles.buttonIcon}>🎥</span>
                              End to End Product Video
                            </button>
                          )}
                          {order.public_ledger && (
                            <button
                              className={`${styles.actionButton} ${styles.ledgerButton}`}
                              onClick={() => navigate("/ledger")}
                            >
                              <span className={styles.buttonIcon}>📜</span>
                              Public Ledger
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))
          ) : (
            // Show no orders available message with a button
            <div className={styles.noOrders}>
              <p style={{textAlign:"center"}}>{t("No orders available")}</p>
              <button
                className={styles.orderButton}
                onClick={() => navigate("/dharmikx")}
              >
                {t("Click here to place your first order")}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  } else if (panelOption === "savedAddress") {
    panelContent = <SavedAddress />;
  } else if (panelOption === "loginLogout") {
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    localStorage.removeItem("phoneNumber");
    localStorage.removeItem("referral_code");
    localStorage.removeItem("invitedBy");
    localStorage.removeItem("saved_address");
    navigate("/");
  }
console.log(user)
  return (
    <div>
      <Metadata
        description="Celebrate Holi with the divine blessings of Shri Krishna! Order sacred Vrindavan Holi Prasad and Banke Bihari Temple offerings online. The Vrindavan Holi Prasad Box brings the sacred essence of Vrindavan to your home anywhere in India, including prasad from Shri Banke Bihari Temple, blessed tulsi mala, Krishna Ji moorti, and more. Get Holi 2025 Prasad, Holi Prasad Boxes, and divine blessings delivered to your doorstep. Immerse yourself in Krishna’s love and joy this Holi with spiritual Holi rituals, puja offerings, and Braj Holi traditions from Mathura and Vrindavan."
        keywords="Vrindavan Holi Prasad, Online Prasad Booking, Banke Bihari Holi Prasad, Holi 2025 Prasad, Braj Holi Offerings, Krishna Temple Prasad, Mathura Holi Prasad, Divine Prasad Home Delivery, Holi Blessings, Radha Krishna Holi, Spiritual Holi Traditions, Gulaal Offerings, Holi Bhog, Holi Prasad Service, Order Prasad Online, Holi Rituals in Vrindavan, Holi Puja Offerings, Buy Banke Bihari Prasad Online, Order Banke Bihari Temple Prasad, Online Banke Bihari Prasad Delivery, Vrindavan Holi Prasad Online, Holi Prasad Box Online, Sacred Holi Prasad Delivery, Banke Bihari Holi Prasad Box, Vrindavan Temple Prasad Online, Online Prasad from Banke Bihari Mandir, Buy Vrindavan Prasad Online for Holi, Holi Festival Offerings from Vrindavan, Krishna Bhog Prasad Online, Temple Prasad Home Delivery for Holi, Authentic Vrindavan Prasad Box, Online Delivery of Holi Prasad in India, Holi Special Prasad from Vrindavan Temples, Order Sacred Prasad from Vrindavan Temples, Banke Bihari Mandir Holi Offerings Online, Holi Prasad Gift Box from Vrindavan, Vrindavan Devotional Prasad for Holi, Mathura Holi, Mathura Holi 2025, Mathura Holi Dates 2025, Vrindavan Holi 2025, Barsana Holi 2025, Mathura Vrindavan Holi 2025, Brij Holi, Barsana Holi, Nandgaon Holi, Gokul Holi, Mahavan Holi, Goverdhan Holi, Holi, Huranga Holi, Vrindavan Holi, Brindavan Holi, Mathura Holi Calendar, India Holi, Braj Holi 2025 Schedule, Mathura Holi Schedule 2025, Holi Schedule, Colorful Festival Mathura Vrindavan, Bankey Bihari Temple Holi, Krishna Janmabhoomi Temple Holi, Lathmar Holi, Barsana Lathmar Holi, Phoolan Holi, Holi Festival Braja, Holi Celebration in Vrindavan, Charity on Holi, Holi Rituals, Lord Krishna Holi, Spring Festival, Spiritual Holi Celebration, Holi Charity Significance, Vrindavan Holi Traditions, Colors of Holi, Holi in Braja, Vrindavan Festival, Holi Prayers, Holi in Braja Region, Vrindavan Holi Customs, Holi Dance and Music, Holi Festivities in Vrindavan, Holi Community Celebrations, Holi in the Birthplace of Krishna, Holi Devotional Activities, Holi Festival of Love, Charity and Holi, Holi Color Festival, Devotional Holi Celebration, Vrindavan Holi Atmosphere, Holi in the Land of Krishna, Holi Worship and Prayers, Phool Wali Holi, Radha Krishna Holi, Widow's Holi, Holi in Mathura, Holi Traditions, Laddu Mar Holi, Holika Dahan, Dhulandi Holi, Holi Celebrations in India, Braj Region Holi, Krishna Holi Festival, Unique Holi Traditions, Holi Rituals in Braj."
        ogTitle="Order Vrindavan Holi Prasad Online | Banke Bihari Temple Offerings for Holi 2025"
        ogDescription="Celebrate Holi with the divine blessings of Shri Krishna! Order sacred Vrindavan Holi Prasad and Banke Bihari Temple offerings online. The Vrindavan Holi Prasad Box brings the sacred essence of Vrindavan to your home anywhere in India, including prasad from Shri Banke Bihari Temple, blessed tulsi mala, Krishna Ji moorti, and more. Get Holi 2025 Prasad, Holi Prasad Boxes, and divine blessings delivered to your doorstep. Immerse yourself in Krishna’s love and joy this Holi with spiritual Holi rituals, puja offerings, and Braj Holi traditions from Mathura and Vrindavan."
        ogImage="https://d3vqmpzcil03dt.cloudfront.net/webite-assets/dharmik_logo.png"
        ogUrl="https://dharmikapp.in/dharmikx"
        canonicalUrl="https://dharmikapp.in/dharmikx"
        twitter="@dharmikapp"
        youtube="@dharmik_hindi"
        instagram="@dharmik_app"
        author="Dharmik App"
        publisher="Dharmik"
        datePublished="2025-03-08"
       />
      <NavBar />
      <div className={styles.profileContainer}>
        <ToastContainer />
        <div className={styles.mainContent}>
          <div className={styles.panel}>
            <div className={styles.panelOptions}>
              <div className={styles.profileSection}>
                <div>
                  {user?.image ? (
                    <img 
                      src={user.image} 
                      alt="profile_photo" 
                      className={styles.userImage}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = {logo}; 
                      }}
                    />
                  ) : (
                    <div className={styles.defaultUserImage}>
                      <img 
                      src={defaultImage} 
                      alt="profile_photo" 
                      className={styles.userImage}
                      />
                    </div>
                  )}
                </div>
                <div className={styles.userDetails}>
                  <span className={styles.userDetailSpan}>
                    {user?.userName || t("Dharmik user")}
                  </span>
                  <span className={styles.userDetailSpan}>
                    {user?.email || ""}
                  </span>
                  <span className={styles.userDetailSpan}>
                    {phoneNumber || ""}
                  </span>
                </div>
              </div>
              <button onClick={() => handlePanelOptionChange("basic")}>
                {t("Your Details")}
              </button>
              <button onClick={() => handlePanelOptionChange("orders")}>
                {t("Your Orders")}
              </button>
              <button onClick={() => handlePanelOptionChange("savedAddress")}>
                {t("Saved Address")}
              </button>
              <button onClick={() => handlePanelOptionChange("loginLogout")}>
                {t("Log out")}
              </button>
            </div>
          </div>
          <div className={styles.contentArea}>{panelContent}</div>
        </div>
      </div>
      <AmritjalFooter/>
    </div>
  );
};

export default ProfilePage;
